import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface TemplateCardProps {
  title: string;
  description: string;
  imageColor: string;
  onClick: () => void;
  delay?: number;
}
export function TemplateCard({
  title,
  description,
  imageColor,
  onClick,
  delay = 0
}: TemplateCardProps) {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    delay,
    duration: 0.4
  }} data-id="element-40">
      <motion.div whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={onClick} className="group cursor-pointer border border-[#2a2a5a] hover:border-[#ffc978]/50 transition-colors h-full flex flex-col rounded-2xl overflow-hidden bg-[#1a1a3e]" data-id="element-41">
        {/* Preview Placeholder */}
        <div className={`h-40 w-full ${imageColor} relative overflow-hidden`} data-id="element-42">
          <div className="absolute inset-0 bg-black/10 group-hover:bg-transparent transition-colors" data-id="element-43" />

          {/* Overlay Button */}
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 bg-[#0f0f2d]/60 backdrop-blur-[2px]" data-id="element-44">
            <span className="bg-[#ffc978] text-[#0f0f2d] px-4 py-2 rounded-full text-sm font-bold flex items-center transform translate-y-4 group-hover:translate-y-0 transition-transform" data-id="element-45">
              Use Template <ArrowRight size={14} className="ml-2" data-id="element-46" />
            </span>
          </div>
        </div>

        <div className="p-5 flex flex-col flex-grow" data-id="element-47">
          <h3 className="text-lg font-bold text-white mb-2 group-hover:text-[#ffc978] transition-colors" data-id="element-48">
            {title}
          </h3>
          <p className="text-sm text-[#8b8bab] leading-relaxed" data-id="element-49">
            {description}
          </p>
        </div>
      </motion.div>
    </motion.div>;
}